import axios from "axios";
import { toast } from "react-toastify";
import { tokenKeyName } from "../config";

// axios.interceptors.response.use(null, (error) => {
//   const expectedError =
//     (error.response &&
//       error.response.status >= 400 &&
//       error.response.status < 500) ||
//     axios.isCancel(error);

//   if (!expectedError) {
//     //alert("An unexpected error occurred.")
//     toast.error("An unexpected error occurred.");
//   }

//   return Promise.reject(error); //is this why we get a notification of axios error when we try to do anything while server is down and i assume when we have no internet as well?
// });

axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(tokenKeyName);

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    //alert("Could not authorize.");
    //return Promise.reject(error);

    toast.error("Could not authorize.");

    return Promise.reject(error);
  }
);

const httpService = {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
  patch: axios.patch,
};

export default httpService;
